type UserProof = string;

type TaskStatus = "pending" | "completed" | "in-progress";

export type TaskList = {
  id: number;
  requested_by: string;
  requestor_name: string;
  category: string;
  category_id: string;
  message: string;
  user_proofs: UserProof[];
  status: TaskStatus;
  eta: string;
  assigned_at: string;
  task_started_at: string;
  task_ended_at: string;
  created_at: string;
  updated_at: string;
};

export enum ITicketManagementActionTypes {
  FETCH_CATEGORIES_LIST_REQUEST = "FETCH_CATEGORIES_LIST_REQUEST",
  FETCH_CATEGORIES_LIST_SUCCESS = "FETCH_CATEGORIES_LIST_SUCCESS",
  FETCH_CATEGORIES_LIST_FAILURE = "FETCH_CATEGORIES_LIST_FAILURE",

  FETCH_SUB_CATEGORIES_LIST_REQUEST = "FETCH_SUB_CATEGORIES_LIST_REQUEST",
  FETCH_SUB_CATEGORIES_LIST_SUCCESS = "FETCH_SUB_CATEGORIES_LIST_SUCCESS",
  FETCH_SUB_CATEGORIES_LIST_FAILURE = "FETCH_SUB_CATEGORIES_LIST_FAILURE",

  FETCH_TASK_LIST_DETAILS_REQUEST = "FETCH_TASK_LIST_DETAILS_REQUEST",
  FETCH_TASK_LIST_DETAILS_SUCCESS = "FETCH_TASK_LIST_DETAILS_SUCCESS",
  FETCH_TASK_LIST_DETAILS_FAILURE = "FETCH_TASK_LIST_DETAILS_FAILURE",

  CREATE_NEW_TASK_REQUEST = "CREATE_NEW_TASK_REQUEST",
  CREATE_NEW_TASK_SUCCESS = "CREATE_NEW_TASK_SUCCESS",
  CREATE_NEW_TASK_FAILURE = "CREATE_NEW_TASK_FAILURE",
  RESET_NEW_TASK_STATUS = "RESET_NEW_TASK_STATUS",

  UPDATE_NEW_TASK_REQUEST = "UPDATE_NEW_TASK_REQUEST",
  UPDATE_NEW_TASK_SUCCESS = "UPDATE_NEW_TASK_SUCCESS",
  UPDATE_NEW_TASK_FAILURE = "UPDATE_NEW_TASK_FAILURE",
  RESET_UPDATE_TASK_STATUS = "RESET_UPDATE_TASK_STATUS",

  FETCH_TASK_DETAILS_REQUEST = "FETCH_TASK_DETAILS_REQUEST",
  FETCH_TASK_DETAILS_SUCCESS = "FETCH_TASK_DETAILS_SUCCESS",
  FETCH_TASK_DETAILS_FAILURE = "FETCH_TASK_DETAILS_FAILURE",

  FETCH_REQUESTED_TASK_DETAILS_REQUEST = "FETCH_REQUESTED_TASK_DETAILS_REQUEST",
  FETCH_REQUESTED_TASK_DETAILS_SUCCESS = "FETCH_REQUESTED_TASK_DETAILS_SUCCESS",
  FETCH_REQUESTED_TASK_DETAILS_FAILURE = "FETCH_REQUESTED_TASK_DETAILS_FAILURE",

  FETCH_ASSIGNED_TASK_DETAILS_REQUEST = "FETCH_ASSIGNED_TASK_DETAILS_REQUEST",
  FETCH_ASSIGNED_TASK_DETAILS_SUCCESS = "FETCH_ASSIGNED_TASK_DETAILS_SUCCESS",
  FETCH_ASSIGNED_TASK_DETAILS_FAILURE = "FETCH_ASSIGNED_TASK_DETAILS_FAILURE",

  FETCH_TICKETS_ANALYTICS_REQUEST = "FETCH_TICKETS_ANALYTICS_REQUEST",
  FETCH_TICKETS_ANALYTICS_SUCCESS = "FETCH_TICKETS_ANALYTICS_SUCCESS",
  FETCH_TICKETS_ANALYTICS_FAILURE = "FETCH_TICKETS_ANALYTICS_FAILURE",
}

export type ITicketManagementActionCreator = {
  type: string;
  payload: any;
};
